import CertifiedTile from './CertifiedTile';

export default CertifiedTile;
